import { gql } from '@apollo/client';
import { EXECUTOR_FRAGMENT } from './executor';

export const USER_FRAGMENT = gql`
  ${EXECUTOR_FRAGMENT}
  fragment UserReturn on User {
    id
    createdAt
    updatedAt
    name
    phone
    avatar
    allowPermissionNotification
    allowPermissionLocation
    blocked
    executor {
      ...ExecutorReturn
    }
  }
`;

export const ADMIN_USERS = gql`
  ${USER_FRAGMENT}
  query ADMIN_USERS($where: AdminUsersWhereInput, $skip: Int, $take: Int) {
    adminUsers(where: $where, skip: $skip, take: $take) {
      ...UserReturn
    }
    adminUsersCount(where: $where)
  }
`;

export const ADMIN_USER = gql`
  ${USER_FRAGMENT}
  query ADMIN_USER($where: AdminUserWhereInput!) {
    adminUser(where: $where) {
      ...UserReturn
    }
  }
`;

export const ADMIN_BLOCK_USER = gql`
  ${USER_FRAGMENT}
  mutation ADMIN_BLOCK_USER($where: AdminUserWhereInput!, $data: AdminBlockUserInput!) {
    adminBlockUser(where: $where, data: $data) {
      ...UserReturn
    }
  }
`;
